import { observable, makeObservable } from 'mobx';
import { IApiLineupPlayer } from '@trackman/baseball-shared-components';
import { Lineup } from './Lineup';
import { IApiPlayLineup } from '../../interfaces/tagging/ApiModels/IApiStadiumPlayModel';
import { ApiLineupDraggablePlayer } from 'interfaces/team/ApiLineupDraggablePlayer';

export class PlayLineup {
  constructor(homeLineup: ApiLineupDraggablePlayer[], awayLineup: ApiLineupDraggablePlayer[]) {
    this.homeTeam = new Lineup(homeLineup.map(this.copyPlayer));
    this.awayTeam = new Lineup(awayLineup.map(this.copyPlayer));
    makeObservable(this);
  }

  @observable homeTeam: Lineup;

  @observable awayTeam: Lineup;

  toApiModel = () => {
    return {
      homeTeam: this.homeTeam.players,
      awayTeam: this.awayTeam.players,
    } as IApiPlayLineup;
  };

  private copyPlayer = (player: ApiLineupDraggablePlayer): ApiLineupDraggablePlayer => {
    return { ...player, isEnabled: true, name: player.id };
  };
}
